import { render, staticRenderFns } from "./PostalCodeList.vue?vue&type=template&id=4b16a61f"
import script from "./PostalCodeList.vue?vue&type=script&lang=js"
export * from "./PostalCodeList.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeList.vue?vue&type=style&index=0&id=4b16a61f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports